export default {
    cart:(state) => {
        return state.cart
    },
    clientId: (state) => {
        return state.clientId
    },
    client: (state) => {
        return state.client
    },
    posOptions:(state) => {
        return state.posOptions
    },
    cartError:(state) => {
        return state.cartError
    },
    order:(state) => {
        return state.order
    },
    modified:(state) => {
        return state.modified
    },
    products:(state) => {
        return state.products
    },
    categories:(state) => {
        return state.categories
    },
    subTotal:(state) => {
        if(!state.cart.length) return 0
        return state.cart.reduce((total, row) => total + (row.quantity*row.unitPrice),0)
    },
    tax(state, getters){
        return  state.taxRate ? (getters.subTotal * state.taxRate.taxRate / 100) : getters.subTotal
    },
    total(state, getters){
        return (getters.subTotal + getters.tax)
    },
    
    getPrice:(state) => (product) => {
        let price = product.prices.find(p => p.currency == state.currency && p.catalog_id==state.catalogId);
        if(!price) return 0

        return price.includeVat ? price.price / (1 + state.taxRate.taxRate / 100) : price.price

    },
    currency: (state) =>{
        return state.currency
    },
    taxRate: (state) => {
        return state.taxRate
    },
    loading: (state) => {
        return state.loading
    }
}
